<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="ch00_fm03_title"></a><a id="page_iii"></a>One Marriage under God</h1>
<p class="subtitle"><em>The Campaign to Promote Marriage in America</em></p>
<p class="author">Melanie Heath</p>
<p class="images1"><img alt="image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm03_title.vue?4b70b28d